import PlanetSection from '../../components/NewVenus/PlanetSection';

const Venus = () => {
    return <PlanetSection/>;
};

export default Venus;
